import type { IContactInformation } from '~/models/contactInfo/contactInfoModel'

/**
 * 'GENERAL' and 'PAYMENT' are reserved enum values defined in ContactInfoModel.
 * To add new contact info types, extend the enum in ContactInfoModel first,
 * then add the corresponding entry here.
 */
export const contactInformation: IContactInformation = {
	'GENERAL': {
		EN: {phone: {number: '0204 578 0960', countryCallingCode: '+44'}},
		DE: {phone: {number: '0204 578 0960', countryCallingCode: '+44'}},
		ES: {phone: {number: '0204 578 0960', countryCallingCode: '+44'}},
		FR: {phone: {number: '0204 578 0960', countryCallingCode: '+44'}},
	},
	'PAYMENT': {
		EN: {
			phone: {number: '0204 578 0960', countryCallingCode: '+44'},
			openingHours: [
				{day: 'Monday, Tuesday, Thursday, Friday, Saturday: ', hours: '9am - 5pm'},
				{day: 'Wednesday: ', hours: '10am - 5pm'},
				{day: 'Sunday: ', hours: '9am - 5pm'},
			],
		},
		DE: {
			phone: {number: '0204 578 0960', countryCallingCode: '+44'},
			openingHours: [
				{day: 'Montag, Dienstag, Donnerstag, Freitag, Samstag: ', hours: '9:00 - 17:00 Uhr'},
				{day: 'Mittwoch: ', hours: '10:00 - 17:00 Uhr'},
				{day: 'Sonntag: ', hours: '9:00 - 17:00 Uhr'},
			],
		},
		ES: {
			phone: {number: '0204 578 0960', countryCallingCode: '+44'},
			openingHours: [
				{day: 'Lunes, Martes, Jueves, Viernes, Sábado: ', hours: '9:00 - 17:00'},
				{day: 'Miércoles: ', hours: '10:00 - 17:00'},
				{day: 'Domingo: ', hours: '9:00 - 17:00'},
			],
		},
		FR: {
			phone: {number: '0204 578 0960', countryCallingCode: '+44'},
			openingHours: [
				{day: 'Lundi, Mardi, Jeudi, Vendredi, Samedi: ', hours: '9h - 17h'},
				{day: 'Mercredi: ', hours: '10h - 17h'},
				{day: 'Dimanche: ', hours: '9h - 17h'},
			],
		},
	},
}